<template>
  <component :is="layout"></component>
</template>

<script>
import PublicLayout from "@/layouts/publicLayout";
import PrincipalLayout from "@/layouts/principalLayout";

import { mapState } from "vuex";

export default {
  computed: {
    layout() {
      return this.$route.meta.layout || "principal-layout";
    }
  },
  components: {
    PrincipalLayout,
    PublicLayout
  },
  name: "App",
  data() {
    return {
      msg: "Aplicación para gestionar los marcajes"
    };
  },
};
</script>

<style>
page-enter-active,
.page-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.page-enter,
.page-leave-to {
  opacity: 0;
  transform: translateY(-9%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

html {
  overflow-y: auto !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.cursosPointer {
  cursor: pointer;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.v-application .subtitle-2 span {
  font-size: 15px !important;
}

.v-label {
  font-size: 14px !important;
}

.v-btn > .v-btn__content .v-icon.margin {
  margin-right: 8px;
}

.v-card__title.subheading {
  font-size: 16px;
  font-weight: normal;
  color: #78909c;
}

@media (max-width: 959px) {
  .layout.wrap {
    max-width: 100vw;
    margin: 0 !important;
  }
}
</style>
